import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useNavigate } from "react-router";
import Searching from "../components/Searching";
import NoDataFound from "../components/NoDataFound";
import { useDispatch } from "react-redux";
import { authLogin } from "../store/authSlice";
import { Link } from "react-router-dom";
import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import AuthLoader from "../components/loader/AuthLoader";
import unAuthImage from "../assets/image/unauthorized.png";
import successImage from "../assets/image/syncSucess.png";
import Image from "../components/elements/Image";
import { MAIN_LOGO } from "../constant/Constant";

const ChangeEmail = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Change Email"
  );
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const codeNumber = new URLSearchParams(window.location.search).get("code");
  const email = new URLSearchParams(window.location.search).get("email");
  const [loading, setLoading] = useState(true);
  const [dispalayMessage, setDisplayMessage] = useState("");
  const [isCheck, setIsCheck] = useState(1);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isChangePassword, setIsChangePassword] = useState(false);

  const loaderStyles = {
    width: "fit-content",
    fontWeight: "bold",
    fontFamily: "monospace",
    fontSize: "26px",
    color: "#0000",
    background:
      "linear-gradient(90deg, #326E68 calc(50% + 0.5ch), #000 0) right/calc(200% + 1ch) 100%",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    animation: "l7 2s infinite steps(11)",
  };

  const keyframes = `
        @keyframes l7 {
            to { background-position: left; }
        }
    `;

  useEffect(() => {
    const verifyFn = async () => {
      setLoading(true);
      try {
        const userData = await postData("update-email", {
          hash_number: codeNumber,
          email: email,
        });
        if (userData.status && userData.status === 200) {
          setIsCheck(2);
          setLoading(false);
        } else {
          setLoading(false);
          setDisplayMessage(userData.message);
        }
      } catch (error) {
        setLoading(false);
        setDisplayMessage(error.message);
      }
    };
    verifyFn();
  }, []);

  const onChangePassword = async (e) => {
    e.preventDefault();
    setIsChangePassword(true);
    try {
      const userData = await postData("reset-password", {
        hash_number: codeNumber,
        password: password,
        confirm_password: confirmPassword,
      });
      if (userData.status && userData.status === 200) {
        setIsChangePassword(false);
        toastr.success(userData.message);
        return navigate("/signin");
      } else {
        toastr.error(userData.message);
        setIsChangePassword(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsChangePassword(false);
    }
  };

  return (
    <>
      <div className="relative min-h-screen flex items-center justify-center bg-teal-400">
        <div className="absolute inset-0 bg-teal-50 clip-diagonal"></div>

        <div className="relative bg-white rounded-xl shadow-lg p-6 text-center w-[500px]">
        <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
          {isCheck && isCheck === 1 ? (
            <div className="">
              {loading ? (
                <>
                  <div className="flex justify-center items-center mt-8">
                    <AuthLoader />
                  </div>
                  <div className="flex justify-center items-center mt-5">
                    <style>{keyframes}</style>
                    <div style={loaderStyles}>Loading, Please Wait...</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="absolute inset-0 flex items-center justify-center text-[140px] text-teal-300/20 font-extrabold drop-shadow-md pointer-events-none">
                    404
                  </div>
                  <div className="flex items-center justify-center mb-4">
                    <div className="w-20 h-20 flex items-center justify-center mt-4">
                      <img
                        src={unAuthImage}
                        alt="Unauthorized"
                        className="w-26 h-26"
                      />
                    </div>
                  </div>

                  <div className="text-xl mt-4 font-bold text-rose-600">
                    {dispalayMessage || "Invalid Token"}
                  </div>

                  <button
                    onClick={() => navigate("/")}
                    className="mt-2 px-8 py-2 bg-gradient-to-r from-teal-400 to-teal-600 text-white rounded-full hover:scale-105 transition-transform shadow-md hover:shadow-lg"
                  >
                    Go Home
                  </button>
                </>
              )}
            </div>
          ) : (
            <>
              <div className="flex items-center justify-center mb-4">
                <div className="w-20 h-20 flex items-center justify-center mt-4">
                  <img
                    src={successImage}
                    alt="successImage"
                    className="w-26 h-26"
                  />
                </div>
              </div>

              <div className="text-xl mt-4 font-bold text-slate-500">
                {"Your email has been updated successfully!"}
              </div>
              <div className="flex items-center justify-center mt-2">
                <Button
                  buttonClasses="!py-2 !bg-transparent !border !border-teal-600 !text-teal-600  !rounded-full hover:!scale-105 !transition-transform !shadow-md hover:!shadow-lg"
                  buttonLabelClasses="!text-teal-600"
                  buttonType={"button"}
                  buttonIcon={"fa-light fa-arrow-right-to-arc"}
                  buttonIconPosition={"left"}
                  buttonLabel={"Login"}
                  functions={() => navigate("/signin")}
                  buttonHasLink={false}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default ChangeEmail;
